import { __assign } from "tslib";
import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { isLinkItem } from '../utils/utils';
import LinkItem from './link-item';
import ItemIcon from './item-icon';
import styles from './styles.css.js';
var ItemElement = function (_a) {
    var _b;
    var item = _a.item, disabled = _a.disabled, onItemActivate = _a.onItemActivate, highlighted = _a.highlighted, highlightItem = _a.highlightItem, _c = _a.first, first = _c === void 0 ? false : _c, last = _a.last, hasCategoryHeader = _a.hasCategoryHeader, _d = _a.variant, variant = _d === void 0 ? 'normal' : _d;
    var isLink = isLinkItem(item);
    var onClick = function (event) {
        event.preventDefault();
        if (!disabled) {
            onItemActivate(item, event);
        }
    };
    var onLinkClick = function (event) {
        if (!disabled) {
            onItemActivate(item, event);
        }
    };
    var onHover = function (event) {
        event.preventDefault();
        !disabled && highlightItem(item);
    };
    var itemRef = useRef(null);
    useEffect(function () {
        if (highlighted && itemRef.current) {
            itemRef.current.focus();
        }
    }, [highlighted]);
    var commonProps = {
        ref: itemRef,
        className: styles['item-element-inner'],
        role: 'menuitem',
        'aria-disabled': disabled ? 'true' : undefined,
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: disabled ? undefined : highlighted ? 0 : -1
    };
    var hasIcon = !!(item.iconName || item.iconUrl || item.iconSvg);
    return (React.createElement("li", { className: clsx(styles['item-element'], styles["variant-" + variant], (_b = {},
            _b[styles.highlighted] = highlighted,
            _b[styles.disabled] = disabled,
            _b[styles.first] = first,
            _b[styles.last] = last,
            _b[styles['has-category-header']] = hasCategoryHeader,
            _b[styles['item-link']] = isLink,
            _b)), role: "presentation", "data-testid": item.id, "data-description": item.description, onClick: isLink ? onLinkClick : onClick, onMouseEnter: !disabled ? onHover : undefined, onTouchStart: !disabled ? onHover : undefined }, isLink ? (React.createElement(LinkItem, { item: item, disabled: disabled, optionProps: commonProps })) : (React.createElement("span", __assign({}, commonProps),
        hasIcon && React.createElement(ItemIcon, { name: item.iconName, url: item.iconUrl, svg: item.iconSvg, alt: item.iconAlt }),
        ' ',
        item.text))));
};
export default ItemElement;
//# sourceMappingURL=index.js.map